import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortalComponent } from './portal.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PortalHomeComponent } from './pages/portal-home/portal-home.component';
import { MaintenanceModeComponent } from 'src/app/maintenance-mode/maintenance-mode.component';
import { PortalLoginComponent } from './pages/portal-login/portal-login.component';
import { isAuthenticated } from './auth/auth.guard';
import { ModuleGuardService } from 'src/app/guards/module-guard.service';
import { TenantModuleType } from 'src/app/shared/models/tenantModuleType';
import { PageNotFoundComponent } from 'src/app/shared/components/page-not-found/page-not-found.component';
import { CredentialsComponent } from './pages/credentials/credentials.component';
import { PortalProfileComponent } from './pages/portal-profile/portal-profile.component';

const routes: Routes = [
  { path: '', redirectTo: 'portal', pathMatch: 'full' },
  {
    path: 'portal',
    component: PortalComponent,
    canActivate: [ModuleGuardService],
    data: { moduleType: TenantModuleType.Portal },
    children: [
      {
        path: '',
        component: PortalHomeComponent,
        canActivate: [isAuthenticated],
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            component: DashboardComponent,
          },
          {
            path: 'credentials',
            component: CredentialsComponent,
          },
          {
            path: 'profile',
            component: PortalProfileComponent,
          },
          {
            path: 'not-found',
            component: PageNotFoundComponent,
            data: { showToolbar: false },
          },
        ],
      },
      {
        path: 'login',
        component: PortalLoginComponent,
      },
    ],
  },
  { path: 'maintenance-mode', component: MaintenanceModeComponent },
  { path: '**', redirectTo: 'portal/not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class PortalRoutingModule {}
